/**
 * The Benefits container
 */
import { PaginationSection } from "@bkry/bowline-components/PaginationSection";
import { ScrollToTop as useScrollToTop } from "@bkry/bowline-components/Utils";
import { listPartnerDeals } from "@bkry/bowline-redux/partnerDeals";
import { listRaffles } from "@bkry/bowline-redux/raffles";
import { env } from "@bkry/bowline-utils";
import { useSsrEffect } from "@issr/core";
import { useWeb3React } from "@web3-react/core";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import ScrollAnimation from "react-animate-on-scroll";
import { useDispatch, useSelector } from "react-redux";
import { Route, Switch, useHistory, useRouteMatch } from "react-router-dom";
import { NavLink } from "react-router-dom/cjs/react-router-dom";
import { Col, Container, Row, Spinner } from "reactstrap";
import ArtistsIntro from "../components/ArtistsIntro";
import FaqList from "../components/Faqs/FaqList";
import Page from "../components/Page/Page-component";
import { PartnerDealPreview } from "../components/PartnerDeals";
import { RafflePreview } from "../components/Raffles";
const { REACT_APP_PROJECT_ID, REACT_APP_CDN_PATH } = env;
/**
 * Benefits container, the landing page for logged in users
 */
const Benefits = (props, context) => {
  useScrollToTop();
  const locale = useSelector((state) => state?.i18nState?.lang);
  const dispatch = useDispatch();
  const { account } = useWeb3React();
  const totalPagesRaffles = useSelector((state) => state?.raffles?.totalPages);
  const currentPageRaffles = useSelector((state) => state?.raffles?.listPage);
  const totalPagesPartnerDeals = useSelector(
    (state) => state?.partnerDeals?.totalPages
  );
  const currentPagePartnerDeals = useSelector(
    (state) => state?.partnerDeals?.listPage
  );

  const partnerDealsLoading = useSelector(
    (state) => state?.partnerDeals?.loadingList
  );
  const partnerDealsLoaded = useSelector(
    (state) => state?.partnerDeals?.loadedList
  );
  const rafflesLoading = useSelector((state) => state?.raffles?.loadingList);
  const rafflesLoaded = useSelector((state) => state?.raffles?.loadedList);
  // console.log("totalPages", totalPages, currentPage);
  const history = useHistory();
  const urlParams = new URLSearchParams(history.location.search);
  let pageNum = urlParams.get("page");
  let itemNum = urlParams.get("items") || "8";
  let { url } = useRouteMatch();
  console.log("urlParams", urlParams);
  const [selectedType, setSelectedType] = useState(
    history.location.pathname === `/${locale}/community/benefits`
      ? "raffles"
      : "deals"
  );

  const handlePagination = (page, items = itemNum) => {
    urlParams.set("page", page);
    urlParams.set("items", items);
    history.replace(url + "?" + urlParams.toString());
  };

  const dispatchApi = async () => {
    // const sorting = {};
    // const filters = {};
    if (history.location.pathname === `/${locale}/community/benefits/deals`) {
      dispatch(
        listPartnerDeals({
          projectId: REACT_APP_PROJECT_ID,
          pageNum: pageNum,
          itemNum: itemNum,
        })
      );
    } else if (history.location.pathname === `/${locale}/community/benefits`) {
      dispatch(
        listRaffles({
          projectId: REACT_APP_PROJECT_ID,
          pageNum: pageNum,
          itemNum: itemNum,
        })
      );
    }
  };

  useSsrEffect(dispatchApi);
  useEffect(dispatchApi, [dispatch, pageNum, itemNum, account, selectedType]);

  const raffleIds = useSelector((state) => state?.raffles?.idsList);
  const partnerDealIds = useSelector((state) => state?.partnerDeals?.idsList);
  const error = useSelector((state) => state?.tribes?.listError);
  console.log("selectedType", selectedType);
  console.log("error", error);
  console.log("handlePagination", handlePagination);
  const benefitTypes = {
    // highlights: context.t("Highlights"),
    raffles: context.t("Raffles"),
    deals: "Claims", // context.t("Deals"),
  };
  return (
    <Page id="membership-tiers" title={context.t("Holder Benefits")}>
      <div className="d-flex justify-content-center">
        <img
          src={
            (REACT_APP_CDN_PATH || "") + "/images/headers/Benefits_Overview.png"
          }
          className="w-100 img-fluid"
          alt={context.t("Holder Benefits")}
          width="1920"
          height="1080"
        />
      </div>
      <Container className="bigger-margin-top bigger-margin-bottom">
        <ArtistsIntro
          subtitle={context.t("benefits.intro.subtitle")}
          title={context.t("benefits.intro.title")}
          smallText={context.t("benefits.intro.smallText")}
          bigText={context.t("benefits.intro.bigText")}
        />
        <div className="d-flex justify-content-center gap-3 mb-5">
          {Object.entries(benefitTypes).map(([key, value]) => (
            <NavLink
              key={key}
              to={`/${locale}/community/benefits${
                key === "raffles" ? "" : `/${key}`
              }`}
              onClick={() => setSelectedType(key)}
              className={
                "btn cursor-pointer btn-outline-primary border rounded-pill"
              }
              exact
              activeClassName={
                "active text-white bg-secondary btn-outline-primary border rounded-pill"
              }
            >
              {value}
            </NavLink>
          ))}
        </div>
        <Switch>
          <Route exact path={`/${locale}/community/benefits`}>
            {rafflesLoading && !raffleIds?.length && (
              <div className="my-5 text-center">
                <Spinner
                  style={{
                    height: "8rem",
                    width: "8rem",
                    "--bs-spinner-animation-speed": "5s",
                  }}
                />
              </div>
            )}

            {rafflesLoaded && !raffleIds?.length && (
              <p className="text-center">
                {context.t("There aren't raffles available at this time.")}
              </p>
            )}
            {raffleIds.length > 0 && (
              <Row className="my-5">
                {raffleIds?.length >= 3 ? (
                  <>
                    <Col md={6} style={{ marginBottom: "var(--bs-gutter-x)" }}>
                      <RafflePreview raffleId={raffleIds[0]} />
                    </Col>

                    <Col md={6}>
                      <Row>
                        {raffleIds?.slice(1, 3)?.map((raffleId) => (
                          <Col
                            xs={6}
                            key={raffleId}
                            style={{ marginBottom: "var(--bs-gutter-x)" }}
                          >
                            <RafflePreview raffleId={raffleId} />
                          </Col>
                        ))}
                      </Row>
                      <Row>
                        {raffleIds?.slice(3, 5)?.map((raffleId) => (
                          <Col
                            xs={6}
                            key={raffleId}
                            style={{ marginBottom: "var(--bs-gutter-x)" }}
                          >
                            <RafflePreview raffleId={raffleId} />
                          </Col>
                        ))}
                      </Row>
                    </Col>
                    {raffleIds?.slice(5)?.map((raffleId) => (
                      <Col
                        xs={6}
                        md={3}
                        key={raffleId}
                        style={{ marginBottom: "var(--bs-gutter-x)" }}
                      >
                        <RafflePreview raffleId={raffleId} />
                      </Col>
                    ))}
                  </>
                ) : (
                  raffleIds?.map((raffleId) => (
                    <Col
                      xs={6}
                      md={3}
                      key={raffleId}
                      style={{ marginBottom: "var(--bs-gutter-x)" }}
                    >
                      <RafflePreview raffleId={raffleId} />
                    </Col>
                  ))
                )}

                <PaginationSection
                  currentPage={currentPageRaffles}
                  totalPages={totalPagesRaffles}
                  basePath={history.location.pathname}
                  itemNum={itemNum}
                />
              </Row>
            )}
          </Route>
          <Route exact path={`/${locale}/community/benefits/deals`}>
            {partnerDealsLoading && !partnerDealIds?.length && (
              <div className="my-5 text-center">
                <Spinner
                  style={{
                    height: "8rem",
                    width: "8rem",
                    "--bs-spinner-animation-speed": "5s",
                  }}
                />
              </div>
            )}

            {partnerDealsLoaded && !partnerDealIds?.length && (
              <p className="text-center">
                {context.t("There aren't deals available at this time.")}
              </p>
            )}

            {partnerDealIds.length > 0 && (
              <>
                <Row className="my-5">
                  {partnerDealIds?.map((partnerDealId) => (
                    <Col
                      xs={6}
                      md={3}
                      key={partnerDealId}
                      style={{ marginBottom: "var(--bs-gutter-x)" }}
                    >
                      <PartnerDealPreview partnerDealId={partnerDealId} />
                    </Col>
                  ))}
                </Row>
                <PaginationSection
                  currentPage={currentPagePartnerDeals}
                  totalPages={totalPagesPartnerDeals}
                  basePath={history.location.pathname}
                  itemNum={itemNum}
                />
              </>
            )}
          </Route>
        </Switch>
      </Container>
      <Container className="bigger-margin-top bigger-margin-bottom">
        <ScrollAnimation animateIn="zoomIn" duration={2} delay={500}>
          <img
            src={
              (REACT_APP_CDN_PATH || "") +
              "/images/Samsung_Generator_Overview.png"
            }
            alt="Samsung Generator Overview"
            width="100%"
            height="auto"
          />
        </ScrollAnimation>
        <FaqList slug="benefits" />
      </Container>
    </Page>
  );
};

/**  define proptype for the 'translation' function  */
Benefits.contextTypes = {
  t: PropTypes.func,
};

/** export the component as redux connected component */
export default Benefits;
